import { render, staticRenderFns } from "./electricityOrder.vue?vue&type=template&id=ecec2542&"
import script from "./electricityOrder.vue?vue&type=script&lang=js&"
export * from "./electricityOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports